<template>
  <div>
    <div class="vz-customer-view--title" :title="customerTypeText">
      <span class="text-h1">{{ titleCard }}</span>
      
      <vz-label
        v-if="isPayer && !hidePayer"
        variant="success"
        class="ml-10"
        :class="{third: type === 'third'}"
      >Плательщик
      </vz-label>
    
    </div>

    <div class="vz-customer-view">
      <template v-if="isCorporation">
        <div class="flex flex-align-items-center mb-5">
          <div class="mr-5">
            <vz-icon name="domain" :title="customerTypeText" variant="primary" size="16" />
          </div>
          <span v-html="companyName" />
        </div>
        <div class="flex flex-align-items-center mb-5">
          <div class="mr-5">
            <vz-icon name="file-document" :title="customerTypeText" variant="primary" size="16" />
          </div>
          <span>{{ taxIdName }}: {{ taxIdValue }}</span>
        </div>
      </template>

      <div class="flex flex-align-items-center mb-5">
        <div class="mr-5">
          <vz-icon name="account" :title="customerTypeText" variant="primary" size="16" />
        </div>
        <span>ФИО: {{ customerName }}</span>
      </div>
      <div class="flex flex-align-items-center mb-5">
        <div class="mr-5">
          <vz-icon name="phone" variant="primary" size="16" />
        </div>
        <span>Телефон: {{ customer.phone.join(', ') }}</span>
      </div>
      <div v-if="customer.email" class="flex flex-align-items-center mb-5">
        <div class="mr-5">
          <vz-icon name="mail" variant="primary" size="16" />
        </div>
        <span>Email: {{ customer.email }}</span>
      </div>
      <div v-if="orderCustomer.sendCode" class="flex flex-align-items-center mb-5">
        <div class="mr-5">
          <vz-icon name="message-processing" variant="primary" size="16" />
        </div>
        <span>Код получения груза на телефон</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import {OrderCustomer, OrderForm} from '~/types/types';
import VzLabel from '~/components/ui-kit/vz-label.vue';
import VzIcon from '~/components/ui-kit/vz-icon.vue';

const props = defineProps({
  type: {
    type: String as PropType<'destination' | 'dispatch' | 'third'>,
    default: 'dispatch'
  },
  order: {
    type: Object as PropType<OrderForm>,
    default: () => ({})
  },
  hidePayer: {
    type: Boolean,
    default: false
  }
})

const isPayer = computed((): boolean => {
  return props.type === props.order.customer.payer
})

const orderCustomer = computed((): OrderCustomer => {
  return props.order.customer[props.type]
})

const isCorporation = computed((): boolean => {
  return orderCustomer.value.type === 'corporation'
})

const customer = computed((): OrderCustomer['corporation'] & OrderCustomer['individual'] => {
  return orderCustomer.value[orderCustomer.value.type] as OrderCustomer['corporation'] & OrderCustomer['individual']
})

const customerName = computed((): string => {
  return isCorporation.value
    ? customer.value.name || ''
    : customer.value.name?.value || ''
})

const titleCard = computed((): string => {
  switch (props.type) {
    case 'dispatch':
      return 'Отправитель'
    case 'destination':
      return 'Получатель'
    case 'third':
      return 'Третье лицо '
  }
})

const customerTypeText = computed((): string => {
  return isCorporation.value ? 'Юридическое лицо' : 'Физическое лицо'
})

const companyName = computed((): string => {
  const name = customer.value?.companyName?.value || ''
  if (!name) {
    return ''
  }
  return name.replace(/\./g, '.<wbr>')
})

const taxIdName = computed((): string => {
  switch (orderCustomer.value.country) {
    case 'RU':
      return 'ИНН'
    case 'BY':
      return 'УНП'
    case 'KZ':
      return 'БИН'
    default:
      return 'ИНН'
  }
})

const taxIdValue = computed((): string => {
  return customer.value.taxId + (customer.value.IEC ? ` КПП: ${customer.value.IEC}` : '')
})
</script>

<style lang="scss" scoped>
.vz-customer-view {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 16px;

  &--title {
    margin-bottom: 15px;
    .vz-label {
      &.third {
        &::before {
          left: 0;
        }
      }     
    }
  }
}
</style>
